// @see https://github.com/nextcloud/server/blob/ac2bc2384efe3c15ff987b87a7432bc60d545c67/lib/public/Files/StorageNotAvailableException.php#L41
export var STORAGE_STATUS;
(function (STORAGE_STATUS) {
    STORAGE_STATUS[STORAGE_STATUS["SUCCESS"] = 0] = "SUCCESS";
    STORAGE_STATUS[STORAGE_STATUS["ERROR"] = 1] = "ERROR";
    STORAGE_STATUS[STORAGE_STATUS["INDETERMINATE"] = 2] = "INDETERMINATE";
    STORAGE_STATUS[STORAGE_STATUS["INCOMPLETE_CONF"] = 3] = "INCOMPLETE_CONF";
    STORAGE_STATUS[STORAGE_STATUS["UNAUTHORIZED"] = 4] = "UNAUTHORIZED";
    STORAGE_STATUS[STORAGE_STATUS["TIMEOUT"] = 5] = "TIMEOUT";
    STORAGE_STATUS[STORAGE_STATUS["NETWORK_ERROR"] = 6] = "NETWORK_ERROR";
})(STORAGE_STATUS || (STORAGE_STATUS = {}));
export const isMissingAuthConfig = function (config) {
    // If we don't know the status, assume it is ok
    if (!config.status || config.status === STORAGE_STATUS.SUCCESS) {
        return false;
    }
    return config.userProvided || config.authMechanism === 'password::global::user';
};
